var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.3327 3.77169L3.33268 15.7717V18.6671H6.22811L18.2281 6.66712L15.3327 3.77169ZM21.0565 7.60992L7.72321 20.9433C7.47316 21.1933 7.13402 21.3338 6.7804 21.3338H1.99935C1.26297 21.3338 0.666016 20.7368 0.666016 20.0004V15.2194C0.666016 14.8658 0.806492 14.5266 1.05654 14.2766L14.3899 0.943259C14.9106 0.42256 15.7548 0.42256 16.2755 0.943259L21.0565 5.72431C21.5772 6.24501 21.5772 7.08923 21.0565 7.60992Z",
  fill: "currentColor"
})));
export default __webpack_public_path__ + "static/media/pencilEditIcon.ee86b90e.svg";
export { SvgComponent as ReactComponent };